_handleCancel